import * as mobx from 'mobx';
import base from '../util/base';
import { observable, action, useStrict, computed, asMap } from 'mobx';

export class ShareStore {
    @observable msginfo = [];
    shareParams = {};

    @action
    setMsgInfo = (shareParams = {}) => {
        const { commonParam, invalidParam, urlParams } = base.globalStore;
        const { requestid, f_weaver_belongto_userid, f_weaver_belongto_usertype,requestnamenew,requestname,currentUserid } = commonParam;
        const { firstSharer } = urlParams;
        const serialid = shareParams.serialid ? shareParams.serialid : (urlParams.serialid || "");
        const cur_sharer = f_weaver_belongto_userid;
        const first_sharer = firstSharer || f_weaver_belongto_userid;
        const urlstr = `?resourcetype=0&resourceid=${requestid}&isfromchatshare=1&sharer=${currentUserid}&firstSharer=${first_sharer}&serialid=${serialid}&f_weaver_belongto_userid=${f_weaver_belongto_userid}&f_weaver_belongto_usertype=${f_weaver_belongto_usertype}`;
        this.shareParams = {
            "resourcetype": 152,
            "resourceid": requestid,
            "serialid": serialid,
            "firstSharer": first_sharer,
            "f_weaver_belongto_userid": f_weaver_belongto_userid,
            "f_weaver_belongto_usertype": f_weaver_belongto_usertype
        }
        this.msginfo = [{
            sharetitle: requestnamenew ? requestnamenew : requestname,
            linkurl: `/common/chatResource/view.html${urlstr}`,
            objectName: 'FW:CustomShareMsg',
            canforward: 1,
            callbackurl: `/api/common/chatResource/addshare${urlstr}`,
            sharetype: 'workflow',
            shareid: `${requestid}`,
            serialid: serialid,
            opentype: 1,
            opentype_pc: 2,
        }];
        this.joinerParams = {
            showJoiner: true,
            joinerUrl: "/api/workflow/forward/getReqWfNodeOperatorsNew",
            joinerUrlParams: {
                requestid: requestid,
            }
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/share.js